<template>
  <div>
    <!-- <b-button v-if="show_button" :disabled="press" block href="#" variant="primary" @click="$emit('save')">Save</b-button> -->
      <b-card>
        <h4><label for="">{{type.toUpperCase()}}</label></h4>
        {{comment}}
        <hr>
        <b-input-group>
          <b-form-input :disabled="lock" :id="`ph_ip_list_${type}`" v-model="ip" placeholder="ex) 182.28.33.222, support only ip address not support network" @keyup.native.enter="add(ip)"></b-form-input>
          <b-input-group-append>
            <b-button :disabled="lock" variant="primary" @click="add(ip)">Add</b-button>
          </b-input-group-append>
          <b-input-group-append>
            <b-button variant="warning" :disabled="lock || ip_list.length == 0" @click="clear">Clear</b-button>
          </b-input-group-append>
        </b-input-group>
        <b-form-group>
          <b-list-group>
            <b-list-group-item v-for="(item, index) in ip_list" :key="index">
              <i v-if="!lock" class="pull-right fa fa-times " style="cursor:pointer" @click="remove(index)"></i> {{item}}
            </b-list-group-item>
          </b-list-group>
        </b-form-group>
      </b-card>
  </div>
</template>

<script>
export default {
  name: 'ipList',
  props: ['ip_list', 'show_button', 'press', 'type', 'comment', 'lock'],
  components: {},
  data: function () {
  return {
      ip : undefined
    }
  },
  methods: {
    remove(c) { this.$emit('remove', c, this.type); },
    add(c) { this.$emit('add', (c || '').trim(), this.type); this.ip = ''; },
    clear() { this.$emit('clear', this.type); },
  },
  created: function() { console.log('ipList.vue', 'created'); },
  destroyed: function() { console.log('ipList.vue', 'destroyed'); },
  mounted: function() { console.log('ipList.vue', 'mounted'); }

}
</script>
